module.exports = __webpack_public_path__ + "img/lk-menu-letter.ca69a653.svg";